/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import * as Radix from '@radix-ui/themes';

import { styled } from 'fierry/react';


const getColor = ({ $accent }) =>
{
  return $accent ? 'var(--accent-11)' : null;
};


const Base = styled(Radix.Text)`
  color: ${props => getColor(props)};
`;


const Text = ({ accent, ...props }) =>
(
  <Base $accent = {accent} {...props} />
);


const Label = styled(Text)`
  letter-spacing: 0.06em;
  text-transform: uppercase;
`;


Text.Label = (props) =>
(
  <Label size = '1' weight = 'bold' {...props} />
);


Text.Title = (props) =>
(
  <Text size = '2' weight = 'medium' {...props} />
);


Text.Body = (props) =>
(
  <Text size = '2' {...props} />
);


Text.Note = (props) =>
(
  <Text size = '1' color = 'gray' {...props} />
);


export default Text;
